export default __webpack_public_path__ + "static/pledge-77fd32ca9e185367eec4c94bcb590857.jpg";